<template>
  <div :class="$style.act">
    <!-- banner -->
    <img :class="$style.banner" :src="actInfo.banner" alt="" />
    <!-- game -->
    <div :class="$style.game" v-if="actInfo.appName">
      <img :src="actInfo.logo" alt="" />
      <div :class="$style.inner">
        <h4>{{ actInfo.appName }}</h4>
        <div :class="$style.tags">
          <span
            v-for="(item, index) in actInfo.tags"
            :key="index"
            :style="{ color: item.labelInfo }"
            >{{ item.labelName }}</span
          >
        </div>
        <p>
          <span>{{ `${actInfo.score}分` }}</span
          >｜<span>{{ `${actInfo.version}版本` }}</span
          >｜<span>{{ actInfo.depict }}</span>
        </p>
      </div>
      <div :class="$style.download">
        <div @click="download(1)">下载</div>
        <p>{{ actInfo.startTime }}</p>
      </div>
    </div>
    <!-- 活动详情 -->
    <div :class="$style.info">
      <h4>活动详情</h4>
      <pre v-html="actInfo.context"></pre>
    </div>
    <!-- 下载按钮 -->
    <img :class="$style.icon" :src="icon" alt="" @click="download(2)" />
    <!-- 分享 -->
    <div :class="$style.share" v-show="shareShow" @touchmove.prevent>
      <img :src="share" alt="" />
      <img :src="close" @click="shareShow = false" alt="" />
    </div>
  </div>
</template>

<script>
import { actInfo } from "@/apis/heziShare.js";
import { pageLoseTips } from "@/libs/utils";

export default {
  data() {
    return {
      icon: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/download_icon.png",
      share: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/share.png",
      close: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/close.png",
      actInfo: {},
      shareShow: false,
      isWX: false,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      const ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      this.isWX = ua.match(/MicroMessenger/i) == "micromessenger";
      const { actId } = this.$route.query;
      if (!actId || isNaN(actId)) {
        pageLoseTips(this.$toast);
        return
      }
      const r = await actInfo({ actId: actId });
      this.actInfo = r.data;
    },
    download(type) {
      if (this.isWX) {
        this.shareShow = true;
        return;
      }
      window.open(
        type == 1 ? this.actInfo.downloadUrl : this.actInfo.appUrl,
        "_blank"
      );
    },
  },
};
</script>

<style lang='scss' module>
.act {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .title {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    font-weight: 700;
    color: black;
    line-height: 36px;
  }

  .banner {
    width: 100%;
    height: 208px;
    object-fit: cover;
  }

  .game {
    width: 100%;
    height: 80px;
    margin: 14px 0px;
    padding: 0px 25px;
    display: flex;

    > img {
      width: 80px;
      margin-right: 12px;
    }

    .inner {
      width: 150px;
      height: 100%;
      > h4 {
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: left;
        color: #333333;
        line-height: 26px;
        margin-bottom: 6px;
      }
      > p {
        width: 100%;
        font-size: 11px;
        font-family: SourceHanSansCN, SourceHanSansCN-Regular;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 12px;
      }
      .tags {
        width: 100%;
        height: 14px;
        display: flex;
        margin-bottom: 10px;
        > span {
          padding: 1px 2px;
          line-height: 12px;
          box-sizing: border-box;
          border-radius: 4px;
          border-width: 1px;
          border-style: solid;
          text-align: center;
          font-size: 9px;
          margin-right: 4px;
        }
      }
    }

    .download {
      width: 75px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      > div {
        width: 75px;
        height: 28px;
        border-radius: 13px;
        border: 1px solid #ffb017;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: center;
        color: #ffa800;
        line-height: 28px;
        margin-bottom: 10px;
      }
      > p {
        width: 100%;
        font-size: 11px;
        font-family: SourceHanSansCN, SourceHanSansCN-Regular;
        font-weight: 400;
        text-align: center;
        color: #999999;
        line-height: 12px;
      }
    }
  }

  .info {
    width: 360px;
    min-height: 200px;
    background: #f6f6f6;
    border-radius: 8px;
    margin: 5px auto 10px auto;
    padding: 13px 10px 10px 10px;
    > h4 {
      width: 100%;
      font-size: 14px;
      font-family: SourceHanSansCN, SourceHanSansCN-Medium;
      font-weight: 500;
      text-align: left;
      color: #666666;
      line-height: 25px;
    }
    > pre {
      width: 100%;
      font-size: 13px;
      font-family: SourceHanSansCN, SourceHanSansCN-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #999999;
      line-height: 21px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
  .icon {
    width: 70px;
    position: fixed;
    right: 10px;
    bottom: 30px;
  }
  .share {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10;
    > img:nth-child(1) {
      width: 100%;
    }
    > img:nth-child(2) {
      width: 20px;
      display: block;
      margin: 30px auto;
    }
  }
}
</style>